
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Form } from 'react-bootstrap'
import { useDispatch } from 'react-redux'

import useTranslation from '../../../Hooks/UseTranslation'
import { updateTaskFieldAction } from '../../../Redux/Actions/ProgrammationManagerActions'

import InputText from '../components/InputText'
import { useProgrammation } from '../../../Hooks/UseProgrammation'
import { updateTaskField } from '../../../Services/ProgrammationManagerService'


const TaskName = () => {

  const dispatch = useDispatch()

  const { t } = useTranslation()

  const { itemOpened, editingItem, setEditingItem, patchItemOpened, errors, setError, unSetError } = useProgrammation()

  const [ name, setName ] = useState(itemOpened.name)
  const currentTaskId = useRef(itemOpened?._id)
  const pendingSave = useRef<string | null>(null)
  const lastSavedName = useRef(itemOpened?.name || '')

  useEffect(() => {
    if (!itemOpened) return

    if (itemOpened._id !== currentTaskId.current) {
      currentTaskId.current = itemOpened._id
      lastSavedName.current = itemOpened.name || ''
      pendingSave.current = null
      setName(itemOpened.name)
      return
    }

    if (!editingItem && itemOpened.name !== name) {
      setName(itemOpened.name)
      lastSavedName.current = itemOpened.name || ''
    }
  }, [itemOpened, editingItem, name])

  const handleChangeName = useCallback(async (newName?: string) => {
    if (!itemOpened) return

    const value = typeof newName === 'string' ? newName : name

    if (value === itemOpened.name && value === lastSavedName.current) return
    if (pendingSave.current === value) return

    pendingSave.current = value
    setName(value)
    setEditingItem(true)
    unSetError('name')

    const [error] = await updateTaskField(itemOpened._id, 'name', value)

    if (pendingSave.current === value) {
      pendingSave.current = null
    }

    setEditingItem(false)

    if (error) {
      setError({
        field: 'name',
        error: 'ocurrió un error al actualizar el nombre',
      })
      console.log('error', error)
      return false
    }

    patchItemOpened({ name: value })
    lastSavedName.current = value
    await dispatch(updateTaskFieldAction(itemOpened._id, 'name', value))
  }, [dispatch, itemOpened, name, patchItemOpened, setEditingItem, setError, unSetError])

  return (
    <Form.Group>
      <Form.Label>
        {t('PROGRAMMATION_MANAGER:NameLabel')}
      </Form.Label>
      <InputText
        value={name}
        onChange={handleChangeName}
        onBlur={() => handleChangeName()}
        placeholder="Ingresa el nombre"
        delay={1000}
        error={errors.find((error: any) => error.field === 'name')}
      />
    </Form.Group>
  )
}

export default TaskName
